import PropTypes from "prop-types";
import { useClientContext } from "../../ClientContext.jsx";
import { RADIUS } from "../../shared/theme.js";

export default function ImportFormSection({
  importState,
  importParsed,
  importPeriod,
  importRefDate,
  importClientId,
  dynamicClients,
  setImportPeriod,
  setImportRefDate,
  setImportClientId,
  handleImportConfirm,
}) {
  const { T } = useClientContext();

  if (!importParsed || importState === "done") return null;

  return (
    <div
      style={{
        background: T.bg,
        border: `1px solid ${T.border}`,
        borderRadius: RADIUS.md,
        padding: "16px",
        marginTop: 8,
      }}
    >
      <div style={{ fontSize: 12, fontWeight: 700, color: T.text, marginBottom: 12 }}>
        Salvar snapshot como:
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: 12,
          marginBottom: 14,
        }}
      >
        <div>
          <label style={{ fontSize: 11, color: T.sub, display: "block", marginBottom: 4 }}>
            Cliente
          </label>
          <select
            value={importClientId}
            onChange={(e) => setImportClientId(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 10px",
              borderRadius: RADIUS.sm,
              border: `1px solid ${T.border}`,
              fontSize: 12,
              color: T.text,
              background: T.card,
            }}
          >
            {dynamicClients.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name} ({c.id})
              </option>
            ))}
          </select>
        </div>
        <div>
          <label style={{ fontSize: 11, color: T.sub, display: "block", marginBottom: 4 }}>
            Período (ex: Fev/26)
          </label>
          <input
            value={importPeriod}
            onChange={(e) => setImportPeriod(e.target.value)}
            placeholder="Jan/26"
            style={{
              width: "100%",
              padding: "8px 10px",
              borderRadius: RADIUS.sm,
              border: `1px solid ${T.border}`,
              fontSize: 12,
              color: T.text,
              background: T.card,
              boxSizing: "border-box",
            }}
          />
        </div>
        <div>
          <label style={{ fontSize: 11, color: T.sub, display: "block", marginBottom: 4 }}>
            Data de referência
          </label>
          <input
            type="date"
            value={importRefDate}
            onChange={(e) => setImportRefDate(e.target.value)}
            style={{
              width: "100%",
              padding: "8px 10px",
              borderRadius: RADIUS.sm,
              border: `1px solid ${T.border}`,
              fontSize: 12,
              color: T.text,
              background: T.card,
              boxSizing: "border-box",
            }}
          />
        </div>
      </div>
      <button
        onClick={handleImportConfirm}
        disabled={importState === "saving" || !importPeriod || !importRefDate}
        style={{
          padding: "10px 24px",
          borderRadius: RADIUS.sm,
          border: "none",
          background:
            !importPeriod || !importRefDate || importState === "saving" ? "#94A3B8" : T.accent,
          color: "#fff",
          fontWeight: 700,
          fontSize: 13,
          cursor:
            !importPeriod || !importRefDate || importState === "saving" ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        {importState === "saving" ? "⏳ Salvando no Supabase…" : "✅ Confirmar e Salvar Snapshot"}
      </button>
    </div>
  );
}

ImportFormSection.propTypes = {
  importState: PropTypes.string.isRequired,
  importParsed: PropTypes.object,
  importPeriod: PropTypes.string.isRequired,
  importRefDate: PropTypes.string.isRequired,
  importClientId: PropTypes.string.isRequired,
  dynamicClients: PropTypes.array.isRequired,
  setImportPeriod: PropTypes.func.isRequired,
  setImportRefDate: PropTypes.func.isRequired,
  setImportClientId: PropTypes.func.isRequired,
  handleImportConfirm: PropTypes.func.isRequired,
};
